import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';
import InputMask from 'react-input-mask';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class MoodleMissionPeriodsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      loaded: 0,
      dados: [],
      origin: '',
      sync_status: '',
      date_start: '',
      date_finish: '',
    };

    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.exportXls = this.exportXls.bind(this);
    this.formatStaff = this.formatStaff.bind(this);
    this.formatTeam = this.formatTeam.bind(this);
  }

  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if (mode === 'reset') {
      this.setState({ overlay: { message: '', type: '', status: 'closed' } });
    } else {
      this.setState({ overlay: { message: message, type: type, status: status } });
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleMessage() {
    var message = localStorage.getItem('verify_message');
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      this.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
      localStorage.removeItem('verify_message');
    }
  }

  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData());
    }
  }

  buildQuery() {
    var params = [];
    ['origin', 'sync_status', 'date_start', 'date_finish'].forEach((field) => {
      if (this.state[field]) {
        params.push(field + '=' + encodeURIComponent(this.state[field]));
      }
    });

    return params.length > 0 ? '?' + params.join('&') : '';
  }

  loadData() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/moodle/periodos/missao' + self.buildQuery(), {
        method: 'GET',
        mode: 'cors',
        headers: value,
      })
        .then(response => response.json())
        .catch(error => {
          console.error(error);
        })
        .then(responseJson => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson && responseJson.status === 'success') {
            self.setState({ dados: responseJson.data });
          }
        })
        .then(() => {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        });
    });
  }

  search(event) {
    event.preventDefault();
    this.loadData();
  }

  exportXls(event) {
    event.preventDefault();
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/moodle/periodos/missao/exportar' + self.buildQuery(), {
        method: 'GET',
        mode: 'cors',
        headers: value,
      })
        .then(response => response.json())
        .catch(error => {
          console.error(error);
        })
        .then(responseJson => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson && responseJson.status === 'success') {
            window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.handleAlert(responseJson ? responseJson.message : '', responseJson ? responseJson.status : '', 'open');
        });
    });
  }

  formatStaff(cell, row) {
    if (!row.staff_id) {
      return cell;
    }

    return (
      <Link to={'/aluno/editar/' + row.staff_id}>
        {cell}
      </Link>
    );
  }

  formatTeam(cell, row) {
    if (!row.team_id) {
      return cell;
    }

    return (
      <Link to={'/turma/editar/' + row.team_id}>
        {cell}
      </Link>
    );
  }

  render() {
    return (
      <div>
        <Topo></Topo>
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <div className="container-fluid">
          <div className="conteudo">
            <h3 className="page-title pull-left">Períodos Moodle por missão</h3>
            <button type="button" className="btn btn-success pull-right" onClick={this.exportXls}>
              <i className="fa fa-fw fa-file-excel-o"></i> Exportar XLS
            </button>
            <div className="clearfix"></div>
            <hr />

            <form onSubmit={this.search}>
              <div className="row">
                <div className="col-md-3 form-group">
                  <label>Origem</label>
                  <select className="form-control" value={this.state.origin} onChange={this.handleChange.bind(this, 'origin')}>
                    <option value="">Todas</option>
                    <option value="sigtrip">SIGTRIP</option>
                    <option value="sigmec">SIGMEC</option>
                  </select>
                </div>
                <div className="col-md-3 form-group">
                  <label>Status</label>
                  <select className="form-control" value={this.state.sync_status} onChange={this.handleChange.bind(this, 'sync_status')}>
                    <option value="">Todos</option>
                    <option value="synced">Sincronizado</option>
                    <option value="dry_run">Simulado</option>
                    <option value="error">Erro</option>
                  </select>
                </div>
                <div className="col-md-2 form-group">
                  <label>Data inicial</label>
                  <InputMask value={this.state.date_start} maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} />
                </div>
                <div className="col-md-2 form-group">
                  <label>Data final</label>
                  <InputMask value={this.state.date_finish} maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} />
                </div>
                <div className="col-md-2 form-group" style={{ marginTop: '24px' }}>
                  <button type="submit" className="btn btn-primary btn-block">
                    <i className="fa fa-fw fa-search"></i> Buscar
                  </button>
                </div>
              </div>
            </form>

            <BootstrapTable
              data={this.state.dados}
              pagination={true}
              striped={true}
              hover={true}
              exportCSV={true}
              options={{
                exportCSVText: 'Exportar CSV',
                sizePerPage: 100,
                noDataText: 'Não há períodos registrados',
                defaultSortName: 'id',
                defaultSortOrder: 'desc',
              }}
              search={true}
              multiColumnSearch={true}
              searchPlaceholder="Procurar"
            >
              <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="70">ID</TableHeaderColumn>
              <TableHeaderColumn dataField="origin_label" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="100">Origem</TableHeaderColumn>
              <TableHeaderColumn dataField="remote_training_id" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="120">Treinamento</TableHeaderColumn>
              <TableHeaderColumn dataField="team_name" dataFormat={this.formatTeam} dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="220">Turma</TableHeaderColumn>
              <TableHeaderColumn dataField="staff_name" dataFormat={this.formatStaff} dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="220">Aluno</TableHeaderColumn>
              <TableHeaderColumn dataField="matter_name" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="220">Matéria</TableHeaderColumn>
              <TableHeaderColumn dataField="access_status_label" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="190">Acesso</TableHeaderColumn>
              <TableHeaderColumn dataField="range_finish_str" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="120">Fim efetivo</TableHeaderColumn>
              <TableHeaderColumn dataField="mission_block_finish_str" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="140">Fim missão</TableHeaderColumn>
              <TableHeaderColumn dataField="sync_status_label" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="130">Sincronização</TableHeaderColumn>
              <TableHeaderColumn dataField="synced_at_str" dataAlign="center" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="150">Sincronizado em</TableHeaderColumn>
              <TableHeaderColumn dataField="error_message" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Procurar' }} width="260">Erro</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }
}

export default MoodleMissionPeriodsIndex;



// WEBPACK FOOTER //
// ./src/Components/Teams/MoodleMissionPeriodsIndex.js